import React, {Component} from "react";
import config from 'react-global-configuration';

class SkuFilter extends Component {
    state = {
        merchant_sku: false,
    };
    componentDidMount(){

    }
    resetSkuFilter() {
        this.setState({
            merchant_sku: 0,
        })
    }

    handleCheckSKU(e){
        var merchant_sku = 1;
        if (e.target.checked === true) {
            this.setState({merchant_sku: 1})
        } else {
            this.setState({merchant_sku: 0});
            merchant_sku = 0;
        }
        this.props.onSelectSku(merchant_sku);
    }
    render() {
        return (
        <label>
            <input type="checkbox" name="merchant_sku" onChange={this.handleCheckSKU.bind(this)}
            checked={(this.state.merchant_sku == 1) ? true : false}/> &nbsp;  Merchant SKU </label>
        );

    }
}
export default SkuFilter;